<template>
  <b-container class="text-center">
    <b-row align-h="center" class="mb-5">
      <b-col cols="10" md="6">
        <!-- TODO: multiple of these; one per question -->
        <b-form-group 
          :label="formConfig.reference.label" 
          label-class="h5"
          :label-for="formConfig.reference.id"
          :state="stateReference"
          v-slot="{ ariaDescribedBy }"
          :validated="formSubmitted"
        >
          <b-form-radio-group buttons button-variant="outline-dark" stacked
            class="d-flex flex-column align-items-start mt-3"
            :aria-describedby="ariaDescribedBy"
            :id="formConfig.reference.id"
            :name="formConfig.reference.name"
            v-model.trim="formData.reference"
            :state="stateReference"
          >
            <b-form-radio class="btb-radio-button"
              v-for="{ text, value } in randomizedOptions"
              :key="value"
              :value="value"
            >
              {{ text }}
            </b-form-radio>
          </b-form-radio-group>

          <b-form-group class="mt-3" v-if="formData.reference === optionOther.value">
            <span class="btb-form-description">Please provide response with minimum 5 characters</span>
            <b-textarea class="flex-grow-1"
              v-bind="formConfig.reference"
              v-model.trim="formData.other"
            />
          </b-form-group>

        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { GET_SURVEY_OPTIONS, IS_PERSON } from '@/store/getters';
import { UPDATE_HEARD_FROM } from '@/store/mutations';
import { isOptionOther } from '@/utils';
import { SURVEYS, SURVEY_ID } from '@/store/state';
import { validateBeforeRouteLeave } from '@/utils/mixins/validateBeforeRouteLeave';

export const PROMOTION_EVENTS = {
  COMPLETED: 'PromotionStep:Completed'
}

export default {
  name: 'Promotion',
  mixins: [
    validateBeforeRouteLeave
  ],
  props: {
    heardFrom: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        reference: this.heardFrom.id ?? null,
        other: this.heardFrom.detail ?? null
      },
      formSubmitted: false,
      allOptions: [
        { text: "I don't remember", value: 29 },
        { text: "Instagram, someone's post", value: 7 },      
        { text: "TikTok, someone's post", value: 8 },         
        { text: "Ad on Meta (i.e. Facebook or Instagram)", value: 19 },
        { text: "Heard about it from a friend, family, or colleague", value: 2 },
        { text: "Google", value: 4 },                       
        { text: "Billboard", value: 20 },                    
        { text: "TV", value: 22 },                          
        { text: "News Article", value: 24 },                 
        { text: "Radio", value: 21 },                      
        { text: "Flyer", value: 25 },                       
        { text: "Drove/Walked Past Location", value: 23 },  
        { text: "Other (Please specify):", value: 6 },
        { text: "Jewish Publication", value: 9, condition: "Brooklyn" },
        { text: "Ad in ACVB (Atlanta Conventions and Visitors Bureau)", value: 25, condition: "Atlanta" }
      ]
    }
  },
  computed: {
    ...mapState([
      SURVEYS,
      SURVEY_ID
    ]),
    ...mapGetters({
      surveyOptions: GET_SURVEY_OPTIONS,
      isPerson: 'IS_PERSON'
    }),
    optionOther() {
      const options = this.formConfig?.reference?.options ?? [];
      return options.find(({ text }) => isOptionOther(text)) || {};
    },
    canProceed() {
      const { reference, other } = this.formData;
      return (
        (reference === this.optionOther?.value)
          ? other?.length >= 5
          : !!reference
      );
    },
    formConfig() {
      const surveyId = this[SURVEY_ID];
      const surveyConfig = this.surveyOptions[surveyId];

      if (!surveyConfig) {
        console.error(`Survey configuration not found for surveyId: ${surveyId}`);
        return {};
      }

      return {
        reference: {
          id: 'promotion-reference',
          label: surveyConfig.label || 'Unknown Label',
          name: 'reference',
          options: this.randomizedOptions
        }
      };
    },
    stateReference() {
      return this.formSubmitted ? this.canProceed : null;
    },
    randomizedOptions() {
  let location = process.env.VUE_APP_LOCATION_CITY_NAME;

  let options = this.allOptions.filter(option => {
    if (option.condition) {
      return option.condition === location;
    }
    return true;
  });

  options = options.map(option => {
    if (location === 'Atlanta' && option.text === 'Flyer') {
      return { ...option, value: 27 };
    }
    return option;
  });

  if (!this.isPerson) {
    options.push({ text: "Invited for an Event (Corporate, Birthday, etc)", value: 28 });
  }

  let alwaysFirst = options.find(option => option.value === 29); 
  let alwaysLast = options.find(option => option.value === 6);   

  let middleOptions = options.filter(option => option.value !== 29 && option.value !== 6);

  console.log(JSON.stringify(middleOptions))
  for (let mid = middleOptions.length - 1; mid > 0; mid--) {
    const j = Math.floor(Math.random() * (mid + 1)); 
    [middleOptions[mid], middleOptions[j]] = [middleOptions[j], middleOptions[mid]];
  }

  return [alwaysFirst, ...middleOptions, alwaysLast];
}

  },

  mounted() {
    if (this.canProceed) this.completeStep(true);

  },
  watch: {
    canProceed(fresh) {
      this.completeStep(fresh);
    }
  },
  methods: {
    completeStep(isComplete) {
      this.$emit(PROMOTION_EVENTS.COMPLETED, isComplete ? this : null);
    },
    validateForm() {
      this.formSubmitted = true;
      return this.canProceed;
    },
    updateHeardFrom() {
      try {
        this.$store.commit(UPDATE_HEARD_FROM, {
          id: this.formData.reference,
          detail: this.formData.other
        });
      } catch (err) {
        console.error(`There was an error updating the Heard About Us details`);
        console.error(err);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.updateHeardFrom();
    if (to.name === 'Guardian') {
      const isValid = this.validateForm();
      return next(isValid);
    }

    return next();
  }
}
</script>

<style lang="scss" scoped>

</style>
